import { DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { OpportunityClient, ProspectsClient, SettingsClient, V1InsightsClient } from 'api-clients/sales-api-client';
import { OpportunityService } from 'src/app/sales-center/opportunity/opportunity.service';
import { ActivityService } from 'src/shared/activity/activity.service';
import { DialogOpportunitiesComponent } from 'src/shared/dialog-opportunities/dialog-opportunities.component';
import { VerticalInsetDirective } from 'src/shared/directives/vertical-divider-inset.directive';
import { DiscussionFollowersDialogComponent } from 'src/shared/discussion-followers-dialog/discussion-followers-dialog.component';
import { EVAComponent } from 'src/shared/eva/eva.component';
import { LegacyWorkspaceService } from 'src/shared/legacy-workspace.service';
import { SharedSalesCenterService } from 'src/shared/sales-center/shared-sales-center.service';
import { InsightService } from '../sales-center/agency-insights/insight.service';
import { LeadsService } from '../sales-center/leads/leads.service';
import { WorkspaceComponent } from '../workspace/workspace.component';
import { DiscussionModule } from './discussion/discussion.module';
import { OpportunityComponent } from './opportunity/opportunity.component';
import { OpportunityModule } from './opportunity/opportunity.module';
import { PanelTypeDirective } from './panel-type.directive';
import { ScrollHeaderDirective } from './scroll-header.directive';
import { AttachmentService } from './shared/attachment.service';
import { TaskFormModule } from './shared/task-form/task-form.module';
import { TaskListModule } from './task-list/task-list.module';
import { TextMessagingComponent } from './text-messaging/text-messaging.component';
import { WorkflowsModule } from './workflows/workflows.module';
import { WorkspaceService } from './workspace.service';
import { EzFileUploadComponent } from 'src/shared/ez-file-upload/ez-file-upload.component';

@NgModule({
  declarations: [
    WorkspaceComponent,
    PanelTypeDirective,
    ScrollHeaderDirective,
  ],
  imports: [
    VerticalInsetDirective,
    OpportunityModule,
    WorkflowsModule,
    TaskListModule,
    DiscussionModule,
    TaskFormModule,
    DiscussionFollowersDialogComponent,
    DialogOpportunitiesComponent,
    EVAComponent,
    TextMessagingComponent,
    EzFileUploadComponent,
  ],
  exports: [
    WorkspaceComponent,
    OpportunityComponent,
  ],
  providers: [
    DatePipe,
    ActivityService,
    OpportunityService,
    InsightService,
    AttachmentService,
    LegacyWorkspaceService,
    WorkspaceService,
    LeadsService,
    { provide: OpportunityClient, useValue: new OpportunityClient() },
    { provide: V1InsightsClient, useValue: new V1InsightsClient() },
    { provide: ProspectsClient, useValue: new ProspectsClient() },
    { provide: SettingsClient, useValue: new SettingsClient() },
    SharedSalesCenterService,
  ],
})
export class WorkspaceModule { }
